import { useEffect, useState, useRef } from "react";
import { TabList, TabPanel, Tabs, Tab } from "react-tabs";
import SingleProgress from "../../../components/Progress";
import Men from "../../../assets/img/men.jpg";
import defualt from "../../../assets/img/admin/defualt.png";
import ChangePassword from "./ChangePassword";
import StatusUpdateComponent from "./StatusUpdateComponent";

const getSocialIcon = (url) => {
  if (!url) return "fa-regular fa-globe";
  if (url.includes("facebook.com")) return "fab fa-facebook";
  if (url.includes("twitter.com")) return "fab fa-twitter";
  if (url.includes("linkedin.com")) return "fab fa-linkedin";
  if (url.includes("instagram.com")) return "fab fa-instagram";
  return "fa-regular fa-globe";
};

const formatDate = (dateString) => {
  if (!dateString) return "NA";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "NA";
  return date
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
    .replace(/\//g, "-");
};

const MemberDetailed = ({ member, leadershipRole }) => {
  const rolesData =
    leadershipRole?.roles?.map((role, index) => {
      let roleName = role.designationId?.name || "";

      return {
        sno: index + 1,
        role: roleName,
        period: `${role.from}–${role.to}`,
      };
    }) || [];

  const initialFormData = {
    profileInfo: {
      title: "Mr.",
      firstName: "",
      middleName: "",
      lastName: "",
      dob: "",
      gender: "Male",
      photo: "",
    },
    communication: {
      email: "",
      telephone: "",
      whatsapp: "",
      mobile: "",
      address: "",
      city: "",
      zipcode: "",
      country: "IN",
      socialLinks: ["", "", ""],
    },
    organization: {
      organizationName: "",
      organizationType: "Private Enterprise",
      organizationAddress: "",
      organizationPhone: "",
      organizationEmail: "",
      aboutCompany: "",
      companyLogo: "",
    },
    workExperience: {
      experienceYears: 0,
      experienceMonths: 0,
    },
    interests: {
      speciesOfInterest: [],
      speciesOther: "",
      fieldOfWork: [],
      natureOfWork: [],
      natureOther: "",
    },
    educationDetails: "",
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (member) {
      setFormData({
        profileInfo: {
          title: member.profileInfo?.title || "NA",
          firstName: member.profileInfo?.firstName || "NA",
          middleName: member.profileInfo?.middleName || "NA",
          lastName: member.profileInfo?.lastName || "NA",
          dob: member.profileInfo?.dob
            ? new Date(member.profileInfo.dob).toISOString().split("T")[0]
            : "NA",
          gender: member.profileInfo?.gender || "NA",
          photo: member.profileInfo?.photo || "NA",
        },
        communication: {
          email: member.communication?.email || "NA",
          telephone: member.communication?.telephone || "NA",
          whatsapp: member.communication?.whatsapp || "NA",
          mobile: member.communication?.mobile || "NA",
          address: member.communication?.address || "NA",
          city: member.communication?.city || "NA",
          zipcode: member.communication?.zipcode || "NA",
          country: member.communication?.country || "NA",
          socialLinks: [
            member.communication?.socialLinks?.[0] || "NA",
            member.communication?.socialLinks?.[1] || "NA",
            member.communication?.socialLinks?.[2] || "NA",
          ],
        },
        organization: {
          organizationName: member.organization?.organizationName || "NA",
          organizationType: member.organization?.organizationType || "NA",
          organizationAddress: member.organization?.organizationAddress || "NA",
          organizationPhone: member.organization?.organizationPhone || "NA",
          organizationEmail: member.organization?.organizationEmail || "NA",
          aboutCompany: member.organization?.aboutCompany || "NA",
          companyLogo: member.organization?.companyLogo || "NA",
        },
        workExperience: {
          experienceYears: member.workExperience?.experienceYears || 0,
          experienceMonths: member.workExperience?.experienceMonths || 0,
        },
        interests: {
          speciesOfInterest: member.interests?.speciesOfInterest || [],
          speciesOther: member.interests?.speciesOther || "NA",
          fieldOfWork: member.interests?.fieldOfWork || [],
          natureOfWork: member.interests?.natureOfWork || [],
          natureOther: member.interests?.natureOther || "NA",
        },
        educationDetails: member.educationDetails || "NA",
      });
    }
  }, [member]);

  const personalinformation = [
    {
      icon: "fa-regular fa-user",
      content: formData.profileInfo.gender,
      label: "Gender",
    },
    {
      icon: "fa-regular fa-calendar",
      content: formatDate(formData.profileInfo.dob),
      label: "Date of Birth",
    },
    {
      icon: "fa-regular fa-mobile",
      content: formData.communication.mobile,
      label: "Mobile",
    },
    {
      icon: "fab fa-whatsapp",
      content: formData.communication.whatsapp,
      label: "WhatsApp",
    },
    {
      icon: "fa-regular fa-phone-alt",
      content: formData.communication.telephone || "N/A",
      label: "Telephone",
    },
    {
      icon: "fa-regular fa-envelope",
      content: formData.communication.email,
      label: "Email",
    },
    {
      icon: "fa-regular fa-map-marker-alt",
      content: formData.communication.address,
      label: "Address",
    },
    {
      icon: "fa-regular fa-map-pin",
      content: formData.communication.city,
      label: "City",
    },
    {
      icon: "fa-regular fa-mail-bulk",
      content: formData.communication.zipcode,
      label: "Zip Code",
    },
    {
      icon: "fa-regular fa-flag",
      content: formData.communication.country,
      label: "Country",
    },
  ];

  const socialLinks = formData.communication.socialLinks.filter(
    (link) => link && link !== "NA"
  );

  const organizationInfo = [
    {
      label: "Organization Name",
      content: formData.organization.organizationName,
      icon: "fas fa-building",
    },
    {
      label: "Organization Type",
      content: formData.organization.organizationType,
      icon: "fas fa-briefcase",
    },
    {
      label: "Organization Address",
      content: formData.organization.organizationAddress,
      icon: "fas fa-map-marker-alt",
    },
    {
      label: "Organization Phone",
      content: formData.organization.organizationPhone,
      icon: "fas fa-phone-alt",
    },
    {
      label: "Organization Email",
      content: formData.organization.organizationEmail,
      icon: "fas fa-envelope",
    },
    {
      label: "About Company",
      content: formData.organization.aboutCompany,
      icon: "fas fa-info-circle",
    },
  ];

  const educationinformationareaofinteres = [
    {
      speciesOfInterest: formData.interests.speciesOfInterest,
      fieldOfWork: formData.interests.fieldOfWork,
      natureOfWork: formData.interests.natureOfWork,
      educationDetails: formData.educationDetails,
      experience: formData.workExperience.experienceYears?.toString() || "0",
    },
  ];

  const fullName = `${formData.profileInfo.title} ${
    formData.profileInfo.firstName
  } ${
    formData.profileInfo.middleName === "NA"
      ? ""
      : formData.profileInfo.middleName
  } ${formData.profileInfo.lastName}`;

  return (
    <main className="min-h-screen">
      <div className="py-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white shadow-xl rounded-2xl overflow-hidden">
            <Tabs>
              {/* Horizontal Profile Header */}
              <div className="bg-gradient-to-r from-[#4f22d8] to-[#6366f1] p-8">
                <div className="flex flex-col lg:flex-row items-center lg:items-start space-y-6 lg:space-y-0 lg:space-x-8">
                  {/* Profile Image */}
                  <div className="relative flex-shrink-0">
                    <div className="w-32 h-32 rounded-full border-4 border-white shadow-lg overflow-hidden bg-white">
                      <img
                        className="w-full h-full object-cover"
                        src={formData.profileInfo.photo || Men}
                        alt="Member"
                        onError={(e) => {
                          e.target.src = Men;
                        }}
                      />
                    </div>
                    <div className="absolute bottom-2 right-2 w-5 h-5 bg-green border-2 border-white rounded-full"></div>
                  </div>

                  {/* Profile Details */}
                  <div className="flex-1 space-y-6">
                    {/* Header Section */}
                    <div className="text-center lg:text-left">
                      <h1 className="text-3xl lg:text-4xl font-bold text-white mb-4">
                        {fullName}
                      </h1>

                      {/* ID and Designation Badges */}
                      <div className="flex flex-wrap justify-center lg:justify-start gap-3">
                        <div className="flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2 shadow-sm h-10">
                          <span className="text-sm font-medium text-white whitespace-nowrap">
                            ID: {member?.membershipId || "N/A"}
                          </span>
                        </div>
                        <div className="flex items-center bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2 h-10 shadow-sm">
                          <span className="text-sm font-medium text-white whitespace-nowrap">
                            {member?.memberDesignation?.name || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Stats Grid */}
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                      <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center hover:bg-white/15 transition-colors">
                        <div className="text-2xl lg:text-3xl font-bold text-white mb-1">
                          {formData.workExperience.experienceYears || 0}
                        </div>
                        <div className="text-xs lg:text-sm text-white/80 font-medium">
                          Years Experience
                        </div>
                      </div>

                      <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center hover:bg-white/15 transition-colors">
                        <div className="text-2xl lg:text-3xl font-bold text-white mb-1">
                          {formData.interests.speciesOfInterest.length}
                        </div>
                        <div className="text-xs lg:text-sm text-white/80 font-medium">
                          Species of Interest
                        </div>
                      </div>

                      <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center hover:bg-white/15 transition-colors">
                        <div className="text-2xl lg:text-3xl font-bold text-white mb-1">
                          {formData.interests.fieldOfWork.length}
                        </div>
                        <div className="text-xs lg:text-sm text-white/80 font-medium">
                          Work Fields
                        </div>
                      </div>

                      <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center hover:bg-white/15 transition-colors">
                        <div className="text-2xl lg:text-3xl font-bold text-white mb-1">
                          {rolesData.length}
                        </div>
                        <div className="text-xs lg:text-sm text-white/80 font-medium">
                          Active Roles
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Social Links */}
                  {socialLinks.length > 0 && (
                    <div className="flex-shrink-0">
                      <h3 className="text-white font-semibold mb-4 text-center lg:text-left">
                        Social Links
                      </h3>
                      <div className="flex gap-1 justify-center lg:justify-start">
                        {socialLinks.map((link, index) => (
                          <a
                            key={index}
                            href={link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-colors"
                          >
                            <i
                              className={`${getSocialIcon(link)} text-white`}
                            ></i>
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Tab Navigation */}
              <TabList className="flex border-b border-gray-200 bg-gray-50">
                <Tab className="px-6 py-4 text-sm font-medium text-gray-600 cursor-pointer hover:text-[#4f22d8] border-b-2 border-transparent hover:border-[#4f22d8] transition-colors react-tabs__tab--selected:text-[#4f22d8] react-tabs__tab--selected:border-[#4f22d8]">
                  <i className="fas fa-user mr-2"></i>
                  Profile
                </Tab>
                <Tab className="px-6 py-4 text-sm font-medium text-gray-600 cursor-pointer hover:text-[#4f22d8] border-b-2 border-transparent hover:border-[#4f22d8] transition-colors react-tabs__tab--selected:text-[#4f22d8] react-tabs__tab--selected:border-[#4f22d8]">
                  <i className="fas fa-lock mr-2"></i>
                  Change Password
                </Tab>

                <Tab
                  className="px-6 py-4 text-sm font-medium text-gray-600 cursor-pointer 
    hover:text-[#4f22d8] border-b-2 border-transparent 
    hover:border-[#4f22d8] transition-colors 
    react-tabs__tab--selected:text-[#4f22d8] 
    react-tabs__tab--selected:border-[#4f22d8]"
                >
                  <i className="fas fa-user mr-2"></i>
                  Login Access
                </Tab>
              </TabList>

              {/* Profile Tab Content */}
              <TabPanel>
                <div className="p-8 space-y-8">
                  {/* Personal Information Section */}
                  <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                    <div className="bg-[#4f22d8] px-6 py-4">
                      <h3 className="text-xl font-bold text-white flex items-center">
                        <i className="fas fa-user mr-3"></i>
                        Personal Information
                      </h3>
                    </div>
                    <div className="p-6">
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {personalinformation.map(
                          (item, index) =>
                            item.content &&
                            item.content !== "NA" && (
                              <div
                                key={index}
                                className="flex items-start space-x-3 p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                              >
                                <div className="flex-shrink-0">
                                  <div className="w-10 h-10 bg-[#4f22d8] rounded-lg flex items-center justify-center">
                                    <i
                                      className={`${item.icon} text-white text-sm`}
                                    ></i>
                                  </div>
                                </div>
                                <div className="flex-1 min-w-0">
                                  <p className="text-sm font-medium text-gray-900 mb-1">
                                    {item.label}
                                  </p>
                                  <p className="text-sm text-gray-600 break-all">
                                    {item.content.startsWith("http") ? (
                                      <a
                                        href={item.content}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-[#4f22d8] hover:underline"
                                      >
                                        {item.content}
                                      </a>
                                    ) : (
                                      item.content
                                    )}
                                  </p>
                                </div>
                              </div>
                            )
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Organization Details Section */}
                  <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                    <div className="bg-[#4f22d8] px-6 py-4">
                      <h3 className="text-xl font-bold text-white flex items-center">
                        <i className="fas fa-building mr-3"></i>
                        Organization Details
                      </h3>
                    </div>
                    <div className="p-6">
                      <div className="flex flex-col lg:flex-row lg:space-x-8 space-y-6 lg:space-y-0">
                        {/* Company Logo */}
                        <div className="flex-shrink-0 text-center lg:text-left">
                          <div className="w-32 h-32 mx-auto lg:mx-0 rounded-xl border-2 border-gray-200 overflow-hidden bg-gray-50">
                            <img
                              className="w-full h-full object-contain p-2"
                              src={formData.organization.companyLogo || defualt}
                              alt="Organization"
                              onError={(e) => {
                                e.target.src = defualt;
                              }}
                            />
                          </div>
                        </div>

                        {/* Organization Info */}
                        <div className="flex-1 space-y-4">
                          {organizationInfo.map((item, index) => (
                            <div
                              key={index}
                              className="flex items-start space-x-3 p-4 bg-gray-50 rounded-lg"
                            >
                              <div className="flex-shrink-0">
                                <div className="w-8 h-8 bg-[#4f22d8] rounded-full flex items-center justify-center">
                                  <i
                                    className={`${item.icon} text-white text-xs`}
                                  ></i>
                                </div>
                              </div>
                              <div className="flex-1 min-w-0">
                                <p className="text-sm font-semibold text-gray-900 mb-1">
                                  {item.label}
                                </p>
                                <p className="text-sm text-gray-600">
                                  {item.content && item.content !== "NA" ? (
                                    item.content
                                  ) : (
                                    <span className="italic text-gray-400">
                                      Not provided
                                    </span>
                                  )}
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Education & Interests Section */}
                  <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                    <div className="bg-[#4f22d8] px-6 py-4">
                      <h3 className="text-xl font-bold text-white flex items-center">
                        <i className="fas fa-graduation-cap mr-3"></i>
                        Education & Area of Interest
                      </h3>
                    </div>
                    <div className="p-6 space-y-6">
                      {/* Species of Interest */}
                      {educationinformationareaofinteres[0].speciesOfInterest
                        .length > 0 && (
                        <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-5">
                          <h4 className="text-lg font-semibold text-[#4f22d8] mb-3 flex items-center">
                            <i className="fas fa-fish mr-2"></i>
                            Species of Interest
                          </h4>
                          <div className="flex flex-wrap gap-2">
                            {educationinformationareaofinteres[0].speciesOfInterest.map(
                              (tag, index) => (
                                <span
                                  key={index}
                                  className="px-4 py-2 bg-white border border-[#4f22d8] text-[#4f22d8] rounded-full text-sm font-medium hover:bg-[#4f22d8] hover:text-white transition-colors cursor-pointer"
                                >
                                  {tag}
                                </span>
                              )
                            )}
                          </div>
                        </div>
                      )}

                      {/* Field of Work */}
                      {educationinformationareaofinteres[0].fieldOfWork.length >
                        0 && (
                        <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-lg p-5">
                          <h4 className="text-lg font-semibold text-[#4f22d8] mb-3 flex items-center">
                            <i className="fas fa-briefcase mr-2"></i>
                            Field of Work
                          </h4>
                          <div className="flex flex-wrap gap-2">
                            {educationinformationareaofinteres[0].fieldOfWork.map(
                              (tag, index) => (
                                <span
                                  key={index}
                                  className="px-4 py-2 bg-white border border-green-500 text-green-700 rounded-full text-sm font-medium hover:bg-green-500 hover:text-white transition-colors cursor-pointer"
                                >
                                  {tag}
                                </span>
                              )
                            )}
                          </div>
                        </div>
                      )}

                      {/* Nature of Work */}
                      {educationinformationareaofinteres[0].natureOfWork
                        .length > 0 && (
                        <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg p-5">
                          <h4 className="text-lg font-semibold text-[#4f22d8] mb-3 flex items-center">
                            <i className="fas fa-cogs mr-2"></i>
                            Nature of Work
                          </h4>
                          <div className="flex flex-wrap gap-2">
                            {educationinformationareaofinteres[0].natureOfWork.map(
                              (tag, index) => (
                                <span
                                  key={index}
                                  className="px-4 py-2 bg-white border border-purple-500 text-purple-700 rounded-full text-sm font-medium hover:bg-purple-500 hover:text-white transition-colors cursor-pointer"
                                >
                                  {tag}
                                </span>
                              )
                            )}
                          </div>
                        </div>
                      )}

                      {/* Education Details */}
                      <div className="bg-gray-50 rounded-lg p-5">
                        <h4 className="text-lg font-semibold text-[#4f22d8] mb-3 flex items-center">
                          <i className="fas fa-book mr-2"></i>
                          Education Details
                        </h4>
                        <p className="text-gray-700 leading-relaxed">
                          {formData.educationDetails &&
                          formData.educationDetails !== "NA"
                            ? formData.educationDetails
                            : "No education details provided"}
                        </p>
                      </div>

                      {/* Work Experience */}
                      <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-lg p-5">
                        <h4 className="text-lg font-semibold text-[#4f22d8] mb-4 flex items-center">
                          <i className="fas fa-chart-line mr-2"></i>
                          Work Experience in Aquaculture
                        </h4>
                        <div className="flex items-center space-x-4">
                          <div className="text-3xl font-bold text-[#4f22d8]">
                            {formData.workExperience.experienceYears || 0}
                          </div>
                          <div className="flex-1">
                            <div className="text-sm text-gray-600 mb-2">
                              Years of Experience
                            </div>
                            <SingleProgress
                              progress={Math.min(
                                formData.workExperience.experienceYears || 0,
                                20
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Leadership Roles Section */}
                  {rolesData.length > 0 && (
                    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                      <div className="bg-[#4f22d8] px-6 py-4">
                        <h3 className="text-xl font-bold text-white flex items-center">
                          <i className="fas fa-crown mr-3"></i>
                          Leadership Roles in SAP
                        </h3>
                      </div>
                      <div className="overflow-x-auto">
                        <table className="w-full">
                          <thead className="bg-gray-50">
                            <tr>
                              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">
                                S.NO
                              </th>
                              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">
                                ROLE
                              </th>
                              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">
                                PERIOD
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {rolesData.map((item, index) => (
                              <tr
                                key={item.sno}
                                className="hover:bg-gray-50 transition-colors"
                              >
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                  <div className="w-8 h-8 bg-[#4f22d8] text-white rounded-full flex items-center justify-center text-xs font-bold">
                                    {item.sno}
                                  </div>
                                </td>
                                <td className="px-6 py-4 text-sm text-gray-900">
                                  <div className="flex items-center">
                                    <i className="fas fa-user-tie text-[#4f22d8] mr-3"></i>
                                    <span className="font-medium">
                                      {item.role}
                                    </span>
                                  </div>
                                </td>
                                <td className="px-6 py-4 text-sm text-gray-600">
                                  <div className="flex items-center">
                                    <i className="fas fa-calendar text-[#4f22d8] mr-3"></i>
                                    <span>{item.period}</span>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {/* Recommendations Section */}
                  {member?.recommendations &&
                    member.recommendations.length > 0 && (
                      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                        <div className="bg-[#4f22d8] px-6 py-4">
                          <h3 className="text-xl font-bold text-white flex items-center">
                            <i className="fas fa-handshake mr-3"></i>
                            Recommendations
                          </h3>
                        </div>
                        <div className="p-6">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {member.recommendations.map(
                              (recommendation, index) => (
                                <div
                                  key={recommendation._id || index}
                                  className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-5 border border-gray-200"
                                >
                                  <div className="flex items-start space-x-4">
                                    <div className="w-12 h-12 bg-[#4f22d8] rounded-full flex items-center justify-center flex-shrink-0">
                                      <i className="fas fa-user-check text-white"></i>
                                    </div>
                                    <div className="flex-1 space-y-3">
                                      <div>
                                        <h4 className="text-lg font-semibold text-gray-900">
                                          {recommendation.name}
                                        </h4>
                                        <p className="text-sm text-[#4f22d8] font-medium">
                                          Member ID:{" "}
                                          {recommendation.membershipNumber}
                                        </p>
                                      </div>

                                      <div className="space-y-2">
                                        <div className="flex items-center text-sm text-gray-600">
                                          <i className="fas fa-building text-[#4f22d8] mr-2 w-4"></i>
                                          <span>
                                            {recommendation.companyName}
                                          </span>
                                        </div>

                                        <div className="flex items-center text-sm text-gray-600">
                                          <i className="fas fa-phone text-[#4f22d8] mr-2 w-4"></i>
                                          <span>{recommendation.mobile}</span>
                                        </div>

                                        <div className="flex items-center text-sm text-gray-600">
                                          <i className="fas fa-envelope text-[#4f22d8] mr-2 w-4"></i>
                                          <span>{recommendation.email}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                          </div>

                          {/* Note about recommendations */}
                          <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                            <div className="flex items-start space-x-3">
                              <i className="fas fa-info-circle text-yellow-600 mt-1"></i>
                              <div>
                                <p className="text-sm text-yellow-800">
                                  <strong>Note:</strong> Each membership
                                  application is supported by two members of the
                                  Society of Aquaculture Professionals as per
                                  the membership requirements.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              </TabPanel>

              {/* Change Password Tab Content */}
              <TabPanel>
                <ChangePassword memberId={member?._id} />
              </TabPanel>

              <TabPanel>
                <StatusUpdateComponent
                  memberId={member?._id}
                  initialStatus={member?.memberAuthStatus}
                />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    </main>
  );
};

export default MemberDetailed;
